<div id="maphome" class="map demo-area"></div>

<div class="space-btn"></div>

<div class="clr-row">
  <div
    *ngFor="let property of homePageMetaData | keyvalue"
    class="clr-col-lg-3 clr-col-6"
  >
    <div class="card">
      <div class="card-header">
        {{ property.value.title }}
      </div>

      <div class="card-block">
        <!-- <div class="card-text">
                    ...
                </div> -->
        <div class="card-img">
          <img src="{{ property.value.logoUrl }}" alt="{{ property.key }}" />
        </div>
      </div>
      <div class="card-footer">
        <button class="btn btn-sm btn-link">
          <a
            href="{{ property.value.siteUrl }}"
            target="_blank"
            rel="noopener noreferrer"
          >
            <clr-icon shape="world" class="is-solid" size="24"></clr-icon>
          </a>
        </button>

        <button class="btn btn-sm btn-link">
          <a
            clrVerticalNavLink
            class="nav-link nav-icon"
            routerLink="/{{ property.value.routerLink }}"
            routerLinkActive="active"
            title="{{ property.value.routerLink }}"
          >
            <clr-icon
              shape="video-gallery"
              class="is-solid"
              size="24"
            ></clr-icon>
          </a>
        </button>
      </div>
    </div>
  </div>
</div>
